export default "__VITE_ASSET__5fdfe755__"